// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".optional[data-v-2d432f27]{color:#bbbcbc}", ""]);
// Exports
module.exports = exports;
